import { ConfigProvider, Spin } from "antd";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import AuditLogsPage from "../pages/AuditLogsPage";
import Dashboard from "../pages/Dashboard";
import DevicesPage from "../pages/DevicesPage";
import InkjetPrintersPage from "../pages/InkjetPrintersPage";
import Login from "../pages/Login";
import PickToLightPage from "../pages/PickToLightPage";
import RedisPage from "../pages/RedisPage";
import DataManCamerasPage from "../pages/DataManCamerasPage";
import ScalesPage from "../pages/ScalesPage";

const App: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundColor: "#f5f5f5",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#6366f1",
          borderRadius: 12,
          fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
        },
      }}
    >
      <Routes>
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
        />
        <Route
          path="/"
          element={
            isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/devices"
          element={
            isAuthenticated ? <DevicesPage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/devices/tcp"
          element={
            isAuthenticated ? <DevicesPage protocolFilter="tcp" /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/devices/mqtt"
          element={
            isAuthenticated ? <DevicesPage protocolFilter="mqtt" /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/scales"
          element={
            isAuthenticated ? <ScalesPage /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/pick-to-lights"
          element={
            isAuthenticated ? (
              <PickToLightPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/inkjet-printers"
          element={
            isAuthenticated ? (
              <InkjetPrintersPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/audit-logs"
          element={
            isAuthenticated ? (
              <AuditLogsPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dataman-cameras"
          element={
            isAuthenticated ? (
              <DataManCamerasPage />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/redis"
          element={
            isAuthenticated ? <RedisPage /> : <Navigate to="/login" replace />
          }
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ConfigProvider>
  );
};

export default App;
